"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var config_1 = tslib_1.__importDefault(require("../bannerModule/config"));
var config_2 = tslib_1.__importDefault(require("../adBannerModule/config"));
var config_3 = tslib_1.__importDefault(require("../productListing/config"));
var config_4 = tslib_1.__importDefault(require("../bannerModuleGroup/config"));
var config_5 = tslib_1.__importDefault(require("../bannerModuleOverlay/config"));
var config_6 = tslib_1.__importDefault(require("../bannerModuleStrip/config"));
var config_7 = tslib_1.__importDefault(require("../bannerModuleCarousel/config"));
var config_8 = tslib_1.__importDefault(require("../bannerSlider/config"));
var config_9 = tslib_1.__importDefault(require("../productCarousel/config"));
var config_10 = tslib_1.__importDefault(require("../productHighlight/config"));
var config_11 = tslib_1.__importDefault(require("../externalVideoModule/config"));
var config_12 = tslib_1.__importDefault(require("../videoModule/config"));
var config_13 = tslib_1.__importDefault(require("../textLinks/config"));
var config_14 = tslib_1.__importDefault(require("../staticNavigation/config"));
var getWidgetConfig = function (widgetID) {
    switch (widgetID) {
        case 'banner_module':
            return config_1.default;
        case 'ad_banner_module':
            return config_2.default;
        case 'banner_module_group':
            return config_4.default;
        case 'banner_module_overlay':
            return config_5.default;
        case 'banner_module_strip':
            return config_6.default;
        case 'banner_module_carousel':
            return config_7.default;
        case 'banner_slider':
            return config_8.default;
        case 'listing':
        case 'product_listing':
            return config_3.default;
        case 'product_carousel':
            return config_9.default;
        case 'product_highlight':
            return config_10.default;
        case 'external_video_module':
            return config_11.default;
        case 'video_module':
            return config_12.default;
        case 'text_links':
            return config_13.default;
        case 'static_navigation':
            return config_14.default;
        default:
            return false;
    }
};
exports.default = getWidgetConfig;
//# sourceMappingURL=getWidgetConfig.js.map